<script setup>
import CompBreadCrumbs from "@/components/CompBreadCrumbs"
import IconsComp from "@/components/IconsComp"
import { useProgramStore, useAuthStore } from '@/stores'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const user = useAuthStore().user
const programs = ref([])
onMounted(async () => {
    programs.value = await useProgramStore().all().then(response => response.data)
})

function programToReturn() {
    !user ? localStorage.setItem('program', JSON.stringify('continuos-flow')) : ''
}

function handleProposalClick(program) {
    const routeName = 'adicionar-programa-' + program.nome.replace('.', '').toLowerCase()
    if (user) {
        router.push({ name: routeName })
    } else {
        localStorage.setItem('returnUrl', JSON.stringify({ name: routeName }))
        router.push({ name: 'primeiro-acesso-proponente' })
    }
}

</script>

<template>
    <div class="back-programas">
        <div class="container mx-auto px-6 content-programas py-12">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
                <div class="font-bold text-blue-800 text-center text-5xl z-20">
                    <img src="@/assets/img/site/programas.png" alt="Programas" class="w-auto h-auto" />
                </div>
                <div>
                    <div class="text-blue-800 font-poppins font-bold text-4xl lg:text-5xl mb-8">Transforme sua inovação em realidade</div>
                    <p>Junte-se ao ecossistema de inovação do Hospital das Clínicas da FMUSP e participe da transformação de ideias em soluções que melhoram a vida das pessoas e fortalecem a saúde do amanhã.</p>
                    <p>Na comunidade InovaHC, você pode transformar projetos em negócios inovadores, ampliar seu networking e contribuir para gerar resultados que impactam positivamente o sistema de saúde.</p>
                    <router-link @click.prevent="programToReturn"
                        :to="user ? { name: 'adicionar-programa' } : { name: 'primeiro-acesso-proponente' }">
                        <button type="button" class="btn primary">Cadastre seu projeto!</button>
                    </router-link>
                    <p class="pt-8 flex justify-start font-bold text-sm">
                        Atenção: O InovaHC não realiza compra de produtos ou serviços de tecnologia, trabalhamos com
                        codesenvolvimento tecnológico de soluções para saúde que atendam a critérios de diferencial de
                        inovação, impacto social, viabilidade técnica, aderência aos desafios do complexo e
                        sustentabilidade.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="bg-purple-50">
        <div class="container mx-auto px-6 py-12">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                <div class="text-3xl md:text-5xl font-poppins mb-4 md:max-w-lg font-bold text-purple-800">Conheça os nossos programas</div>
                <div class="text-purple-800">
                    <p class="pb-4">O InovaHC apoia projetos em diferentes etapas de desenvolvimento por meio de programas estruturados, cada um pensado para atender às necessidades de inovação em saúde.</p>
                    <p class="font-bold">Cada programa atende uma fase específica do desenvolvimento tecnológico de projetos de inovação:</p>
                    <p><b>In.spire</b> | Intraempreendedorismo em saúde</p>
                    <p><b>In.cube</b> | Da ideia ao primeiro protótipo</p>
                    <p><b>In.pulse</b> | Da validação ao piloto</p>
                </div>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 z-20">
                <div v-for='program in programs' :key="program.id" class="card z-20">
                    <div class="text-purple-800 text-2xl font-bold font-poppins pb-2">
                        <span class="text-gray-300">{{ program.id }}.</span> {{ program.nome }}
                    </div>
                    <p class="pb-8 text-purple-800">
                        {{ program.descricao }}
                    </p>
                    <div v-if="program.ultimoEdital"
                        class="flex items-center mt-auto justify-between sticky top-[100vh] max-lg:justify-center max-lg:flex-col max-lg:flex-row max-lg:items-center max-lg:gap-4">

                        <router-link :to="{ name: 'programas-' + program.nome.replace('.', '').toLowerCase() }"
                            class="max-lg:w-full">
                            <button type="button" class="btn primary lg:mr-auto max-lg:w-full">Ver
                                mais
                            </button>
                        </router-link>
                        <a
                            v-if="program.id!=1&&$moment(program.ultimoEdital.abertura) <= $moment() && $moment(program.ultimoEdital.encerramento) >= $moment()"
                            @click.prevent="handleProposalClick(program)"
                            class="font-bold no-underline lg:ml-auto cursor-pointer">
                            Inscreva-se
                        </a>
                        <a v-if="program.id==1&&$moment(program.ultimoEdital.abertura) <= $moment() && $moment(program.ultimoEdital.encerramento) >= $moment()" href="https://docs.google.com/forms/d/e/1FAIpQLSfF1-k6fJkix6W_LLYPh05CsQCA0WYMSRRvLBTk5krTbyKwAQ/viewform" class="font-bold no-underline lg:ml-auto">Inscreva-se</a>
                        <router-link :to="{ name: 'programas-' + program.nome.replace('.', '').toLowerCase() }" v-else
                            class="tag red no-underline lg:ml-auto cursor-pointer">
                            Inscrições encerradas
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>